import React from 'react';
import { ExternalLink, Calendar, ThumbsUp } from 'lucide-react';

const GoogleBusinessPosts = () => {
  const googleBusinessUrl = 'https://share.google/R1GlWWnERVrJWFsuR';

  return (
    <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-2xl p-6 border border-blue-200">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-xl font-bold text-gray-900">
          Aktuelles von uns
        </h3>
        <img
          src="https://www.google.com/images/branding/googlelogo/1x/googlelogo_color_74x24dp.png"
          alt="Google"
          className="h-6"
        />
      </div>

      <p className="text-gray-700 mb-4">
        Folgen Sie uns auf Google, um über aktuelle Angebote, Tipps und 
        Neuigkeiten informiert zu bleiben.
      </p>

      {/* Beispiel-Posts */}
      <div className="space-y-3 mb-4">
        <div className="bg-white rounded-lg p-4 shadow-sm">
          <div className="flex items-start gap-3">
            <Calendar className="w-5 h-5 text-blue-600 mt-1" />
            <div className="flex-1">
              <p className="text-sm font-semibold text-gray-900 mb-1">
                Winteraktion: Türöffnung zum Sonderpreis
              </p>
              <p className="text-xs text-gray-600">
                Profitieren Sie von unserem Winter-Special für Notöffnungen.
              </p>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-lg p-4 shadow-sm">
          <div className="flex items-start gap-3">
            <ThumbsUp className="w-5 h-5 text-blue-600 mt-1" />
            <div className="flex-1">
              <p className="text-sm font-semibold text-gray-900 mb-1">
                Sicherheitstipp: Zylinder überprüfen
              </p>
              <p className="text-xs text-gray-600">
                Vor dem Winter sollten Sie Ihre Schlösser warten lassen.
              </p>
            </div>
          </div>
        </div>
      </div>

      <a
        href={googleBusinessUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-full font-semibold transition-all shadow-md hover:shadow-lg w-full justify-center"
      >
        <ExternalLink className="w-5 h-5" />
        Alle Updates auf Google ansehen
      </a>
    </div>
  );
};

export default GoogleBusinessPosts;
